import React from 'react';
import DivyadesamsDetailPage from '../../panchangam/pages/DivyadesamsDetailPage';

const DivyadesamPage = () => {
  return <DivyadesamsDetailPage />;
};

export default DivyadesamPage;
